export const sizes = [24, 48, 72]

export const sortOptions = [
    {
        id: "score",
        value: {
            name: "Featured",
            sort: [
                {
                    field: "score",
                    order: "desc",
                },
            ],
        },
    },
    {
        id: "revenue",
        value: {
            name: "Best Sellers",
            sort: [
                {
                    field: "stats.revenue",
                    order: "desc",
                },
            ],
        },
    },
    {
        id: 'alphabetical',
        value: {
            name: 'Title ascending',
            sort: [
                {
                    field: 'name',
                    order: 'asc',
                },
            ],
        },
    },
    {
        id: '-alphabetical',
        value: {
            name: 'Title descending',
            sort: [
                {
                    field: 'name',
                    order: 'desc',
                },
            ],
        },
    },
    {
        id: "price",
        value: {
            name: "Price ascending",
            sort: [
                {
                    field: "price",
                    order: "asc",
                },
            ],
        },
    },
    {
        id: "-price",
        value: {
            name: "Price descending",
            sort: [
                {
                    field: "price",
                    order: "desc",
                },
            ],
        },
    },
    {
        id: '-date',
        value: {
            name: 'Newest',
            sort: [
                {
                    field: 'datePublished',
                    order: 'desc',
                },
            ],
        },
    },
    {
        id: 'date',
        value: {
            name: 'Oldest',
            sort: [
                {
                    field: 'datePublished',
                    order: 'asc',
                },
            ],
        },
    },
]

export const defaultConfig = {
    sort: sortOptions[0],
    serpSize: sizes[0],
    autocompleteProductsSize: 4,
    autocompleteKeywordsSize: 5,
    historySize: 5,
    currency: "USD",
}

export const filterNames = {
    "InStock": "In Stock",
    "OutOfStock": "Out of Stock",
    "GIST_GIFT_CARD": "Gift Card",
}

export const popularSearches = window.nostoPopularSearches || [
    { url: "/collections/body-wash-infused-buffers", text: "Body Wash Infused Buffers" },
    { url: "/collections/for-her", text: "For Her" },
    { url: "/collections/new-arrivals", text: "New Arrivals" },
    { url: "/collections/best-sellers", text: "Best Sellers" },
]